import { colors, strings } from "assets/constants";
import { useAboutUs } from "clients/apis";
import { Error, Header, Loading } from "components";
import Text from "components/Text";
import React from "react";
import { Platform, ScrollView } from "react-native";
import WebView from "react-native-webview";
import css from "styles";
import { mq } from "utils";

export default function AboutUs() {
  const { data, isLoading, isError, error, refetch } = useAboutUs();

  const html = `${data?.data.data}`;

  const _renderContent = () => {
    if (isLoading) {
      return <Loading style={{ marginTop: mq(20) }} />;
    }

    if (isError) {
      return <Error reset={refetch} error={error} />;
    }

    return Platform.OS === "web" ? (
      <iframe style={{ borderWidth: 0 }} srcDoc={html} height={"100%"}>
        {data?.data.data}
      </iframe>
    ) : (
      <WebView
        javaScriptEnabled
        scrollEnabled={false}
        automaticallyAdjustContentInsets={false}
        containerStyle={{
          padding: mq(10),
          backgroundColor: colors.white,
          fontSize: mq(15),
        }}
        style={{ fontSize: mq(15) }}
        source={{
          html,
        }}
      />
    );
  };

  return (
    <>
      <Header title={strings.about_us} />
      <ScrollView contentContainerStyle={{ ...css.growContainer }}>
        {_renderContent()}
        <Text>...</Text>
      </ScrollView>
    </>
  );
}
